export default "__VITE_ASSET__BJXvAbir__"